import { useLoaderData } from "@remix-run/react";
import { loader as loaderRoute } from "~/data/loaders/route";
import RoutePage from "./RoutePage";

type RouteProps = {};

export default function Route({}: RouteProps) {
  const { routeType } = useLoaderData<typeof loaderRoute>();

  const isRouteType = (type: string) => {
    return routeType === type;
  };

  const RouteDynamic = () => {
    if (isRouteType("page")) {
      return <RoutePage />;
    } else {
      return null;
    }
  };

  return RouteDynamic();
}
